// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanCreateAgent } from "./hook";

export type CanCreateAgentProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanCreateAgent({
  children,
  fallback,
  scope,
}: CanCreateAgentProps) {
  const canDoAction = useCanCreateAgent(scope);
  return <>{canDoAction ? children : fallback}</>;
}
